import { useState } from "react";
import "./SubscribeModal.css";
import { useLanguage } from '../switchLang/useLang';

function buildMailchimpJsonpUrl(actionUrl) {
    const url = new URL(actionUrl);
    url.pathname = url.pathname.replace("/subscribe/post", "/subscribe/post-json");
    return url;
}

function toQueryString(params) {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;
        searchParams.set(key, value);
    }
    return searchParams.toString();
}

export function MailchimpSubscribeForm({ actionUrl, onSuccess }) {
    const { t } = useLanguage();

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState(null);

    function subscribeWithJsonp() {
        setBusy(true);
        setMessage(null);

        const callbackName = `mc_callback_${Math.random().toString(36).slice(2)}`;
        // Обработка ошибок URL, если вдруг actionUrl пустой
        let url;
        try {
            url = buildMailchimpJsonpUrl(actionUrl);
        } catch (e) {
            setMessage("Error: Invalid Action URL");
            setBusy(false);
            return;
        }

        const params = {
            ...Object.fromEntries(url.searchParams.entries()),
            EMAIL: email.trim(),
            FNAME: firstName.trim(),
            c: callbackName,
        };

        function sanitizeMailchimpMessage(value) {
            const temp = document.createElement("div");
            temp.innerHTML = value ?? "";
            return temp.textContent || temp.innerText || "";
        }

        window[callbackName] = (data) => {
            try {
                if (data?.result === "success") {
                    // Берем текст успеха из переводов
                    setMessage(t("subscribeSuccessText"));
                    onSuccess?.();
                } else {
                    const clean = sanitizeMailchimpMessage(data?.msg);
                    setMessage(clean || "Mailchimp error");
                }
            } finally {
                setBusy(false);
                delete window[callbackName];
            }
        };

        const script = document.createElement("script");
        script.src = `${url.origin}${url.pathname}?${toQueryString(params)}`;
        script.async = true;

        script.onerror = () => {
            setBusy(false);
            // Берем текст ошибки сети из переводов
            setMessage(t("subscribeNetworkError"));
            delete window[callbackName];
        };

        document.body.appendChild(script);

        setTimeout(() => {
            if (window[callbackName]) {
                script.remove();
                delete window[callbackName];
            }
        }, 60_000);
    }

    function onSubmit(event) {
        event.preventDefault();
        if (!email.trim()) return;
        subscribeWithJsonp();
    }

    return (
        <form className="subscribeForm" onSubmit={onSubmit}>
            <div>
                <div className="subscribeLabel">{t("subscribeEmailLabel")}</div>
                <input
                    className="subscribeInput"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t("subscribeEmailPlaceholder")}
                    required
                />
            </div>

            <div>
                <div className="subscribeLabel">{t("subscribeNameLabel")}</div>
                <input
                    className="subscribeInput"
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder={t("subscribeNamePlaceholder")}
                />
            </div>

            <div className="subscribeActions">
                <button className="subscribeButtonPrimary" type="submit" disabled={busy}>
                    {busy ? t("subscribeSending") : t("subscribeSubmit")}
                </button>
            </div>

            {message && <div className="subscribeMessage">{message}</div>}

            <div className="subscribeHint">{t("subscribeHint")}</div>
        </form>
    );
}
